import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { auth } from 'routes/route.map'
import { toaster } from 'utils/toast-wrapper'

import SignupBeneConfirmComponent from './component'

export default combine({
  hooks: [
    withContext(
      'preRegistrationPublicService',
      ServicesContext,
      ({ preRegistrationPublicService }) => preRegistrationPublicService
    ),
    withCallbacks(
      {
        getPreRegBenePublicInfo:
          ({ preRegistrationPublicService }, { match }) =>
          async () => {
            const { token } = match.params
            const content =
              await preRegistrationPublicService.getPreRegBenePublic(token)
            return content
          },
        onSubmit:
          ({ preRegistrationPublicService }, { history, match }) =>
          async (registrationData) => {
            const { token } = match.params
            await preRegistrationPublicService.confirmPreRegBenePublic(
              token,
              registrationData
            )
            toaster.success('Your registration has been confirmed')
            history.push(auth.login())
          },
      },
      []
    ),
  ],
  transformProps: ({ onSubmit, getPreRegBenePublicInfo, match }) => {
    const { token } = match.params
    return {
      onSubmit,
      getPreRegBenePublicInfo,
      token,
    }
  },
})(SignupBeneConfirmComponent)
